module.exports = __webpack_public_path__ + "img/bj_bk_nodata.9eec923d.png";